import { makeStyles } from '@material-ui/core/styles';
import { colorPalette } from 'core/components/theme';
import { THEME_VARIANTS } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  wheelContainer: {
    position: 'relative',
    width: 340,
    height: 340,
    margin: '0 auto'
  },
  wheel: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    position: 'relative',
    overflow: 'hidden',
    border: `4px solid ${colorPalette.white}`,
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  },
  pointer: {
    position: 'absolute',
    top: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 24,
    height: 36,
    backgroundColor: colorPalette.green_90,
    clipPath: 'polygon(50% 100%, 0% 30%, 20% 0%, 80% 0%, 100% 30%)',
    zIndex: 2,
    filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.2))',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 4,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: colorPalette.white
    }
  },
  centerCircle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: colorPalette.white,
    border: `1px solid ${colorPalette.green_90}`,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  centerLogo: {
    width: 30,
    height: 30
  },
  segmentLabel: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '50%',
    transformOrigin: '0 0',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: 15,
    pointerEvents: 'none',
    paddingLeft: 40
  },
  titleText: {
    marginBottom: 8,
    textAlign: 'center'
  },
  subtitleText: {
    marginBottom: 40,
    textAlign: 'center'
  },
  resultPill: {
    marginTop: 24,
    padding: '12px 32px',
    backgroundColor: 'rgba(180, 167, 148, 0.2)',
    borderRadius: 100,
    textAlign: 'center'
  },
  errorText: {
    marginTop: 16,
    color: theme.themeVariant === THEME_VARIANTS.RESKIN ? theme.colorPalette.red_50 : '#c0392b',
    textAlign: 'center'
  },
  wrapper: {
    padding: '40px 24px',
    backgroundColor: colorPalette.beige_40,
    borderRadius: theme.sizes.roundCorners,
    width: '100%',
    maxWidth: 600
  }
});

export default makeStyles(styles);
